// src/config.js

const config = {
    development: {
      API_BASE_URL: "http://localhost:3000",
    },
    production: {
      API_BASE_URL: "https://www.subtitletsunami.com",
    },
  };
  
  export default config[process.env.NODE_ENV];
  